<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="10" :sm="12">
            <el-form-item label="日期范围:">
              <el-date-picker
                v-model="daterange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                class="ele-fluid"
                @change="onDateRangeChoose"
              />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
              <el-button
                @click="
                  (table.where = {
                    startDate: $util.toDateString(new Date(), 'yyyy-MM-dd'),
                    overDate: $util.toDateString(new Date(), 'yyyy-MM-dd'),
                  }) && $refs.table.reload()
                "
                >重置</el-button
              >
              <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon">导出 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column label="教师姓名" prop="tName" align="center" />
          <el-table-column label="开始时间" prop="leave_start_time" align="center" />
          <el-table-column label="结束时间" prop="leave_end_time" align="center" />
          <el-table-column label="请假时长" prop="leave_end_time" align="center">
            <template #default="{ row }">
              <span>{{ ((new Date(row.leave_end_time) - new Date(row.leave_start_time)) / 1000 / 60 / 60).toFixed(2) }} 小时</span>
            </template>
          </el-table-column>
          <el-table-column label="请假原因" prop="description" align="center" />
          <el-table-column label="备注信息" prop="remark" align="center" />
          <el-table-column label="审核教师" prop="auditname" align="center" />
          <!--          <el-table-column label="审核状态" prop="leave_status" />-->
        </template>
      </ele-data-table>
    </el-card>
  </div>
</template>

<script>
  import { exportTeacherLeaveInfo } from '@/config/api';

  export default {
    name: 'Statistics',
    data() {
      return {
        table: {
          // 表格配置
          url: '/teacherLeave/showTeacherLeaveInfo',
          where: {
            startDate: this.$util.toDateString(new Date(), 'yyyy-MM-dd'),
            overDate: this.$util.toDateString(new Date(), 'yyyy-MM-dd'),
          },
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        choose: [], // 表格选中数据
        daterange: [this.$util.toDateString(new Date(), 'yyyy-MM-dd'), this.$util.toDateString(new Date(), 'yyyy-MM-dd')],
      };
    },
    methods: {
      /* 日期选择改变回调 */
      onDateRangeChoose() {
        if (this.daterange) {
          this.table.where.startDate = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd');
          this.table.where.overDate = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd');
        } else {
          this.table.where.startDate = null;
          this.table.where.overDate = null;
        }
      },
      exportData() {
        let data = {};
        if (this.daterange) {
          data.startDate = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd');
          data.overDate = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd');
        } else {
          data.startDate = this.$util.toDateString(new Date(), 'yyyy-MM-dd');
          data.overDate = this.$util.toDateString(new Date(), 'yyyy-MM-dd');
        }
        exportTeacherLeaveInfo(data).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          // console.log(objectUrl)
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          // console.log(res.headers)
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          // console.log(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
    },
  };
</script>

<style scoped></style>
